import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetStaffMemberTermsAndConditions } from '../../../../../../../../../actions/staffActions';

export const useRemoveStaffTermsAndConditions = (id) => {
  const dispatch = useDispatch();
  const [isShowConfirmModalTermsAndConditionsReset, setShowConfirmModalTermsAndConditionsReset] =
    useState(false);

  const onCloseConfirmPopupTermsAndConditionsReset = () => {
    setShowConfirmModalTermsAndConditionsReset(false);
  };

  const onShowConfirmPopupTermsAndConditionsReset = () => {
    setShowConfirmModalTermsAndConditionsReset(true);
  };

  const onResetTermsAndConditions = () => {
    dispatch(resetStaffMemberTermsAndConditions(id));
    onCloseConfirmPopupTermsAndConditionsReset();
  };

  return {
    isShowConfirmModalTermsAndConditionsReset,
    onCloseConfirmPopupTermsAndConditionsReset,
    onShowConfirmPopupTermsAndConditionsReset,
    onResetTermsAndConditions,
  };
};
